import { redirect } from '@tanstack/react-router'

import type { FileRoutesByFullPath } from '@/route-tree.gen'

type ModeRoutePath = Extract<keyof FileRoutesByFullPath, `/$country/$language/$mode/${string}`>

export function redirectHome(from: ModeRoutePath) {
  return redirect({
    from,
    to: '/$country/$language/$mode',
  })
}

export function redirectToScene(from: ModeRoutePath, rangeId: string, id: string) {
  return redirect({
    from,
    params: { id, rangeId },
    to: '/$country/$language/$mode/$rangeId/$id',
  })
}
